// extracted by mini-css-extract-plugin
export default {"root":"LimitedAccessBanner_root__Tva8u","text":"LimitedAccessBanner_text__3_aam","button":"LimitedAccessBanner_button__2yYEa"};